import { Box } from '@gousto-internal/citrus-react'
import React from 'react'

import { PromoBanner, PromoBannerText } from './components/PromoBanner'
import type { Recipe } from '@library/menu-service'
import { LandingPageContent } from '../../landing-page-content/src/LandingPageContent'
import { LandingPageAboveTheFold } from '../../landing-page-above-the-fold/src/LandingPageAboveTheFold'
import { HowItWorksSection } from '@library/landing-pages'

export type HomepageProps = {
  applyDiscount: () => void
  isPromoBannerVisible: boolean
  promoBannerText: string
  onSignupCTAClick: () => void
  signupCTA: string
  recipes: Recipe[]
  isDiscountComprehensionEnabled: boolean
}

export function Homepage({
  applyDiscount,
  promoBannerText,
  isPromoBannerVisible,
  signupCTA,
  onSignupCTAClick,
  recipes,
  isDiscountComprehensionEnabled,
}: HomepageProps) {
  return (
    <Box data-testid="homepage">
      {isPromoBannerVisible && !isDiscountComprehensionEnabled && (
        <PromoBanner applyDiscount={applyDiscount}>
          <PromoBannerText>{promoBannerText}</PromoBannerText>
        </PromoBanner>
      )}
      <LandingPageAboveTheFold
        onCTAClick={onSignupCTAClick}
        signupCTA={signupCTA}
        isDiscountComprehensionEnabled={isDiscountComprehensionEnabled}
      />
      <HowItWorksSection signupCTA={signupCTA} onCTAClick={onSignupCTAClick} />
      <LandingPageContent
        onSignupCTAClick={onSignupCTAClick}
        recipes={recipes}
        signupCTA={signupCTA}
      />
    </Box>
  )
}
